import { render, staticRenderFns } from "./newPay.vue?vue&type=template&id=95afb708&"
import script from "./newPay.vue?vue&type=script&lang=js&"
export * from "./newPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports